import React from 'react';
import ReactQuill from 'react-quill-with-table';
import PropTypes from 'prop-types';


const RichtextEditor = ({ ref, value, modules, onChange }) => {
  const formats = ['bold', 'list', 'bullet', 'link', 'color', 'table', 'blockquote'];

  return (
    <ReactQuill
      ref={ref}
      theme="snow"
    //   theme=""
      modules={modules}
      formats={formats}

      style={{ width: '100%' }}

      value={value}
      onChange={() => {
        if (ref) {
          onChange(ref.getEditor().root.innerHTML);
        }
      }}
    />
  );
};

RichtextEditor.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  modules: PropTypes.object,
};

RichtextEditor.defaultProps = {
  autoFocus: false,
  disabled: false,
  modules: {},
};

export default RichtextEditor;


// WEBPACK FOOTER //
// ./src/app/components/text-field/richtext-editor.js